import CalendarNewPage from './CalendarNewPage';

export default CalendarNewPage;
